<style lang="less">
	.inline{
		display: inline;
	}
</style>
<template>
	<div>

		<h2 class="mw-h1">{{project.clientName}}</h2>
						<p>{{project.description}}</p>

		<v-alert v-if="project.active" dense text type="success">
		Project is live
		</v-alert>		
		<v-alert v-if="!project.active" dense colored-border border="left" type="warning" elevation="">
		Project is not live and not visible to the client
		</v-alert>					
		<v-card>
			<v-tabs
				v-model="tab"
				background-color="white"
				color="black"
				right 
				show-arrows
				pagination
				:icons-and-text="true"
			>
				<v-tabs-slider></v-tabs-slider>

				<v-tab href="#informationTab">
					Project Info <v-icon>mdi-information</v-icon>
				</v-tab>
				<v-tab href="#invitesTab">
					Invites<v-icon>mdi-email-multiple</v-icon>
				</v-tab>
				<v-tab href="#datesTab">
					Schedule<v-icon>mdi-calendar-range</v-icon>
				</v-tab>
				<v-tab href="#candidatesTab">
					Candidates<v-icon>mdi-account-group</v-icon>
				</v-tab>
				<v-tab href="#appointmentsTab">
					Appointments<v-icon>mdi-calendar-account</v-icon>
				</v-tab>
				<v-tab href="#downloadsTab">
					Downloads<v-icon>mdi-folder-download</v-icon>
				</v-tab>
				<v-tab href="#recordingsTab">
					Recordings<v-icon>mdi-file-music</v-icon>
				</v-tab>				
				<v-tab href="#notesTab">
					Notes<v-icon>mdi-notebook</v-icon>
				</v-tab>
				<v-tab href="#invoiceTab">
					Invoices<v-icon>mdi-currency-gbp</v-icon>
				</v-tab>


				<v-tab-item value="recordingsTab">
					<v-card flat tile>
						<v-card-text> 
							<RecordingsList :project="project"></RecordingsList>
						</v-card-text>
					</v-card>
				</v-tab-item>
				<v-tab-item value="invoiceTab">
					<StorageList name="Invoices" :allowUpload="1" :folder="invoicePath" :folders="[]"></StorageList>	
				</v-tab-item>
				<v-tab-item value="informationTab">
					<EditProjectInfo :project="project" v-on:save="save"></EditProjectInfo>
				</v-tab-item>
				<v-tab-item value="invitesTab">
					<EditProjectInvites :project="project" v-on:save="save"></EditProjectInvites>
				</v-tab-item>
				<v-tab-item value="appointmentsTab">
					<v-card flat tile class="pb-5">
						<AppointmentsTable class="mb-5 pb-5" :project="project" ></AppointmentsTable>
						<p class="ml-2"><v-btn color="green" dark @click="save">Save</v-btn></p>
					</v-card>
				</v-tab-item>
				<v-tab-item value="notesTab">
					<v-card flat tile class="pb-5">
						<EditObjectNotes class="mb-5 pb-5" :object="project" v-on:save="save"></EditObjectNotes>
					</v-card>
				</v-tab-item>
				<v-tab-item value="candidatesTab">
					<v-card flat tile class="pb-5">
						<EditProjectCandidates class="mb-5 pb-5" :project="project" ></EditProjectCandidates>
					</v-card>
				</v-tab-item>
				
				<v-tab-item value="datesTab">
					<v-card flat tile class="pa-4">
						<EditProjectDates :project="project" v-on:save="save"></EditProjectDates>
						<Calendar :allowAddAvailability="true" v-on:availabilitySet="updateAvailability" :availability="availabilityEvents" :events="calendarEvents" :toggles="toggles" v-on:clickedEvent="viewEvent"></Calendar>
						<div class="ma-3" v-if="appointmentDialog">
							<v-dialog v-model="appointmentDialog"  transition="dialog-bottom-transition"  max-width="800px">
								<v-card class="pa-3">
									<v-btn absolute right icon @click="appointmentDialog = false">
										<v-icon>mdi-close</v-icon>
									</v-btn>
								</v-card>
							</v-dialog> 
						</div>
					</v-card>
				</v-tab-item>
				<v-tab-item value="downloadsTab">
					<v-card flat tile>
						<EditProjectDownloads :project="project"></EditProjectDownloads>
					</v-card>
				</v-tab-item>
			</v-tabs>
		</v-card>
	</div>
</template>

<script>
import Vue from 'vue'

import Vuex from 'vuex'
import firebase from "firebase";
import {formatDateTime } from "../../assets/utilities.js";

export default {
	name: 'EditProject',
	components: {
		AppointmentsTable: () => import("../tools/AppointmentsTable"),
		EditProjectInfo: () => import('../edits/EditProjectInfo'),
		EditProjectInvites: () => import('../edits/EditProjectInvites'),
		EditObjectNotes: () => import('../edits/EditObjectNotes'),
		EditProjectDates: () => import('../edits/EditProjectDates'),
		EditProjectCandidates: () => import('../edits/EditProjectCandidates'),
		EditProjectDownloads: () => import('../edits/EditProjectDownloads'),
		Calendar: () => import('../tools/Calendar'),
		StorageList: () => import('../tools/StorageList'),
		RecordingsList: () => import( "@/components/subpanels/RecordingsList")

	},
	props: ["project"],
	data: () => ({
	}),
	computed: {    
		...Vuex.mapState({
			view: state => state.auth.view,
			user: state => state.auth.user,
			clients: state => state[state.auth.view].clients,
			panelists: state => state[state.auth.view].panelists,
			appointments: function(state){
				const self = this;
				return state[state.auth.view].appointments.filter( a => a.project == self.project.id )
			},
			projectAvailability: function(state){
				const self = this;
				return state[state.auth.view].projectAvailability.find(a => a.id == self.project.id) 
			}
		}),
		invoicePath(){
			return "organisations/"+this.project.client+"/invoices/"+this.project.id
		},
		availabilityEvents: function(){
			const self = this;
			let availabilities = [];
			if( !self.projectAvailability ){ return; }
			Object.keys(self.project.users).forEach( user => {
				if( self.projectAvailability[user] ){
					let userObj = {displayName: "Your availability", id: user };
					if( user !== self.user.uid  ) {
						let anotherUser = self[`${self.project.users[user]}s`].find( a => a.id == user );
						if( anotherUser ){
							userObj.displayName = anotherUser.displayName + " availability "; 
						}
						else{
							userObj.displayName = "Availability ";
						}
					}
					self.projectAvailability[user].forEach( event => {	
						if( !event.start_time ){
							event.start_time = "00:00"
						}
						if( !event.end_time ){
							event.end_time = "00:00"
						}
						let start = event.start_date + " " + event.start_time;
						let end = event.end_date + " " + event.end_time;
						let availability = {
							...event,
							start,
							end
						}
						availability.userName = userObj.displayName;
						availability.userId = userObj.id;
						availabilities.push(availability)
					})
				}
			})

			return availabilities;
		},
		calendarEvents: function(){
			const self = this;
			const events = [];
			self.appointments.forEach( function(app){
				if( !app.dateTime ){ return; }
				let event = { appointment: app.id };
				let participant = self.panelists.find( p => p.id == app.participant );
				if( participant ){
					event.name = participant.displayName;
				}
				else{
					event.name = event.appointment;
				}
				self.toggles.forEach( key => {
					if( app[key] ){
						event[key] = app[key]
					}
					else if( app.additionalFields && app.additionalFields[key]){
						event[key] = app.additionalFields[key]
					}
					else{
						event[key] = null;
					}
				})
				let date = Vue.moment(app.dateTime.toDate()).format("YYYY-MM-DD")
				let time = Vue.moment(app.dateTime.toDate()).format("HH:mm")
				event.start = date + " " + time;
				if( event.duration ){
					let end = event.dateTime.seconds + (60 * event.duration);
					event.end = end;
				}
				events.push( event )		
			})
			return events
		},
		toggles(){
			var toggles = ["quota"]
			if( this.project.additionalFields ){
				toggles = toggles.concat(this.project.additionalFields)
			}
			return toggles;
		}
	},
	methods: {
		formatDateTime: formatDateTime,	
		save () {
			if( this.project.id ){
				var self = this;
				let update = {};
				for( let key in self.project ){
					update[key] = self.project[key];	
				}
				for( let key in update.dates ){
					if( typeof update.dates[key] == 'string' ){

						let d = new Date(update.dates[key]);
						if( d == "Invalid Date"){
							update.dates[key] = false;
						}
						else{
							//todo - this should be replaced with the formatDateTime() func in utilities
							let stamp = firebase.firestore.Timestamp.fromDate(  d );
							update.dates[key] = stamp;
						}
					}
				}
				
				this.$store.dispatch("updateDoc", {
					doc: "projects/" + self.project.id, 
					action: 'update', 
					data: update  
				}).then( function(){
					self.$emit("saved");
				} )
			}
		},
		updateAvailability: function(events){
			const self = this;
			let uid = self.user.uid;
			let	availabilities = []
			events.forEach( function(event){
				let startDateTime = self.formatDateTime(event.start_date, event.start_time);
				let endDateTime = self.formatDateTime(event.end_date, event.end_time);
				availabilities.push({
					...event,
					startDateTime,
					endDateTime
				})
			} )
			let update = {}
			update[uid] = availabilities;
			this.$store.dispatch("updateDoc", {
				doc: "projectAvailability/" + self.project.id, 
				action: 'update', 
				data: update  
			})
			
		}
    },
	watch: {
		project: {
			immediate: true,
			handler: function( ){
				if( this.project ){
					this.$store.dispatch("bindProject", this.project.id  )
				}
			}
		}
	},
	destroyed: function(){
		// WE SHOULD UNBIND EVERYTHING HERE ---- OR SHOULD WE?

		// this.$store.dispatch( 'unbindProjectInfo' );
	}
};
</script>
